package com.essntl.features.request.ui.allrequest.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun RequestStatus(
    status: RequestModel.Status,
    suffixIconRes: String? = null,
    modifier: Modifier = Modifier,
) {
    val text = remember(status) {
        when (status) {
            RequestModel.Status.Pending -> "Pending"
            RequestModel.Status.Archived -> "Archived"
            RequestModel.Status.InProgress -> "In progress"
            RequestModel.Status.ProposalSent -> "Proposal sent"
            RequestModel.Status.Booked -> "Booked"
            RequestModel.Status.NotBooked -> "Not booked"
            RequestModel.Status.Todo -> "To do"
        }
    }

    val esColorScheme = MaterialTheme.esColorScheme
    val color = remember(status) {
        when (status) {
            RequestModel.Status.Pending -> esColorScheme.textWarning
            RequestModel.Status.Archived -> esColorScheme.textAccent
            RequestModel.Status.InProgress -> esColorScheme.tintedHover
            RequestModel.Status.ProposalSent -> esColorScheme.tintedPressed
            RequestModel.Status.Booked -> esColorScheme.textSuccess
            RequestModel.Status.NotBooked -> esColorScheme.tinted
            RequestModel.Status.Todo -> esColorScheme.textWarning
        }
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        modifier = modifier
            .background(color, CircleShape)
            .widthIn(min = 80.dp)
            .padding(
                vertical = EsConstants.StatusDropdownVerticalPadding,
                horizontal = EsConstants.StatusDropdownHorizontalPadding,
            ),
    ) {
        Text(
            text = text,
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p2Medium14,
        )

        suffixIconRes?.let {
            EsMediumIcon(
                res = it,
                tint = MaterialTheme.esColorScheme.iconPrimary,
            )
        }
    }
}